<div class="sidenav-content">
	<div class="card-block-padding card-title-block flex-block">
		<copo-back-button></copo-back-button>
		<div class="card-title-label" translate>dashboard.efeasibility</div>
		<div class="button-container">
			<button type="button" mat-flat-button (click)="getExcelTemplate()"
				[disabled]="!isProductSubCategory || !isStandardSteelgrade">
				<span translate>efeasibility.excel.template</span>
			</button>
			<button type="button" mat-flat-button color="primary" class="next-button" [disabled]="productCategories.length === 0"
				(click)="openFileImportDialog()">
				<span class="import-button" translate>import.excel</span>
			</button>
		</div>
	</div>

	<copo-efeasibility-first-screen (productCategoryChanged)="handleProductCategoryChange($event)"
		(productSubCategoryChanged)="handleProductSubCategoryChange($event)"
		(soldToNameControlChanged)="handleSoldToNameChange($event)"
		(steelgradesChanged)="handleSteelgradesChange($event)"
		[efeasibilityItems]="efeasibilityItems" [showResults]="displayGrid" [productCategories]="productCategories"
		[soldTos]="soldTos">
	</copo-efeasibility-first-screen>

</div>